module.exports = __webpack_public_path__ + "861a5af957e3cd4fb32d8c58ba141be8.png";